<template>
    <div class="root-wrapper">
        <slot v-if="showContent"></slot>
        <v-app v-else>
            <v-content>
                <v-container>
                    <v-layout wrap justify-center align-center>
                        <v-flex xs12 text-xs-center pt-4 mt-4>
                            <h1 class="title font-weight-light mt-4">Hay problemas con tu cuenta.</h1>
                            <br>
                            <small>
                                {{ message }}
                            </small>
                            <br>
                            <small>
                                {{ additionalMessage }}
                            </small>
                            <v-img :src="require('@/assets/img/account/account_issues.png')" max-width="500"
                                   class="mx-auto"/>
                            <small v-if="isOwner && subscriptionPaused">
                                Debe comunicarse con soporte para mas información.
                                <br>
                                <a href="mailto:contacto@medapp.cl">contacto@medapp.cl</a>
                            </small>
                        </v-flex>
                        <v-flex xs12 text-xs-center>
                            <v-btn v-if="showReviewAccount" color="secondary" small
                                   round class="py-1 px-3" @click="goToSettings">
                                <v-icon size="14" class="mr-1">fa-credit-card</v-icon>
                                revisar cuenta
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-content>
        </v-app>
    </div>

</template>

<script>
import {mapGetters, mapState, mapMutations} from 'vuex'
import {ApiUtils} from '@/utils/ApiUtils';

export default {
    name: "SubscriptionVerifier",
    computed: {
        ...mapGetters([
            'currentSubscription',
            'subscribedPlan',
            'subscriptionWasCancelled',
            'accountSuspended',
            'paymentFailed',
            'planPurchaseNeeded',
            'subscriptionPaused'
        ]),
        ...mapState(['currentProvider']),
        showContent() {
            const vm = this
            return !vm.showSubscriptionVerifier ||
                (vm.showSubscriptionVerifier && !vm.shouldBlock)
        },
        showSubscriptionVerifier() {
            const vm = this
            if (!vm.$route.meta || !vm.$route.meta.subscription) return true
            return Boolean(vm.$route.meta.subscription.verify)
        },
        subscriptionHasIssues() {
            const vm = this
            return vm.paymentFailed || vm.subscriptionWasCancelled || vm.accountSuspended || vm.planPurchaseNeeded || vm.subscriptionPaused
        },
        message() {
            const vm = this
            if (!vm.subscriptionHasIssues) return ''
            if (vm.planPurchaseNeeded) return 'El periodo de prueba ha expirado.'
            if (vm.paymentFailed) return 'El pago ha fallado.'
            if (vm.accountSuspended) return 'Esta cuenta fue suspendida'
            if (vm.subscriptionWasCancelled) return 'Esta subscripción fue cancelada.'
            if (vm.subscriptionPaused) return 'Esta subscripción fue pausada.'
        },
        additionalMessage() {
            const vm = this
            if (!vm.isOwner && vm.subscriptionHasIssues) return 'El dueño de la cuenta debe revisar la subscripción.'
            return ''
        },
        shouldBlock() {
            const vm = this
            const blockCondition = vm.subscriptionWasCancelled || vm.accountSuspended || vm.planPurchaseNeeded || vm.subscriptionPaused;
            if (!vm.$route.meta || !vm.$route.meta.subscription) return blockCondition
            return Boolean(vm.$route.meta.subscription.block) && blockCondition
        },
        showReviewAccount() {
            const vm = this
            return vm.isOwner && vm.$route.name !== 'panel.provider.settings' && !vm.subscriptionPaused
        }
    },
    methods: {
        ...mapMutations(['blurWrapper']),
        logout() {
            ApiUtils.logout()
        },
        goToSettings() {
            this.$router.push({name: 'panel.provider.settings', query: {view: 'SubscriptionSettings'}})
        }
    },
}
</script>

<style scoped>

</style>
